<template>
<div>
    <div class="mt-3">
        <div class="card no-shadow" style="border: 0px;">
            <div class="card-body">
                <div class="row">
                    <div v-for="(usp, idx) in usps" :key="idx" class="col-6 mt-3">
                        <h5>
                            <i class="fa fa-check" :style="`color: ${checkmarkColor};`"></i>
                            {{ usp }}
                        </h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
    checkmarkColor: { type: String, default: undefined },
    usp1: { type: String, default: undefined },
    usp2: { type: String, default: undefined },
    usp3: { type: String, default: undefined },
    usp4: { type: String, default: undefined },
});
const usps = computed(() => [props.usp1, props.usp2, props.usp3, props.usp4]);
</script>

<style>
</style>
